
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { formatToCurrency } from '@/utils/format'
import { DISCOUNT_LABELS } from '@/config/globals'
import styles from './styles.module.scss'
import { isArray } from 'lodash'
import { usePromotionsData } from '@saatva-bits/pattern-library.modules.promotions'

const Strikethrough = ({ item, dataSelector, priceContainerClassName }) => {
    const promotionsData = usePromotionsData()
    const sitewidePromo = promotionsData.sitewidePromo
    const originalPriceSelector = `${dataSelector}_originalPrice`
    const discountsPriceSelector = `${dataSelector}_discountsPrice`
    const products = isArray(item) ? item : [item]

    const { totalOriginalPrice, totalDiscountsPrice } = products.reduce(
        (acc, product) => {
            const { discounts, price, quantity } = product
            let strikethroughPrice = price
            
            // Filter the discounts:
            // If the discount label is the sitewidePromo sale, do not return the discount.
            // If bundles promo are enable and label is bundle, return the discount.
            // If there are fixed amount discounts, return the discount.
            // Other situations, return the discount.
            const discountsFiltered = discounts && discounts.filter((oneDiscount) => {
                let isStrikeThrough = false

                if (sitewidePromo.labels && sitewidePromo.labels.includes(oneDiscount.label)) {
                    isStrikeThrough = false
                }
                if (sitewidePromo.enableBundleDiscounts && (oneDiscount.label === DISCOUNT_LABELS.bundle)) {
                    oneDiscount.amount = price * (sitewidePromo.bundleDiscountPercent / 100)
                    
                    isStrikeThrough = true
                }
                if (sitewidePromo.fixedAmounts) {
                    isStrikeThrough = true
                }
        
                if (oneDiscount.label === DISCOUNT_LABELS.bedframeSale) {
                    isStrikeThrough = false
                }
        
                return isStrikeThrough
            })

            discountsFiltered && discountsFiltered.forEach((oneDiscount) => {
                strikethroughPrice -= (oneDiscount.amount / quantity)
            })
        
            const originalPrice = price * quantity
            const discountsPrice = strikethroughPrice * quantity
        
            return {
                totalOriginalPrice: acc.totalOriginalPrice + originalPrice,
                totalStrikethroughPrice: acc.totalStrikethroughPrice + strikethroughPrice,
                totalDiscountsPrice: acc.totalDiscountsPrice + discountsPrice,
            }
        },
        { totalOriginalPrice: 0, totalStrikethroughPrice: 0, totalDiscountsPrice: 0 }
    )

    const samePrice = totalDiscountsPrice === totalOriginalPrice
    const priceSelector = samePrice ? originalPriceSelector : discountsPriceSelector
    const realPrice = samePrice ? totalOriginalPrice : totalDiscountsPrice

    const priceContainerClasses = classNames(styles.priceContainer, {
        [`${priceContainerClassName}`]: priceContainerClassName
    })

    return (
        <div className={priceContainerClasses}>
            { !samePrice && 
                <h4 className={styles.strikethrough} data-selector={originalPriceSelector}>{formatToCurrency(totalOriginalPrice, {maximumFractionDigits: 0})}</h4>
            }
            <h4 className={styles.price} data-selector={priceSelector}>{formatToCurrency(realPrice, {maximumFractionDigits: 0})}</h4>
        </div>
    )
}

Strikethrough.propTypes = {
    item: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    dataSelector: PropTypes.string.isRequired,
    priceContainerClassName: PropTypes.string
}

export default Strikethrough
